/**
 * HTML estático del case CRT — bisel + screws + power LED + controles
 * + audio toggle + back link + slot del terminal.
 *
 * Lo dejamos como string (no DOM API) para que la pantalla esté
 * lista en un único `innerHTML` y los listeners del input handler
 * encuentren los elementos al primer query.
 */

export function renderCaseShell(): string {
  return `
    <div class="screw tl"></div>
    <div class="screw tr"></div>
    <div class="screw bl"></div>
    <div class="screw br"></div>

    <div class="bezel">
      <div class="screen" id="screen">
        <a href="/" class="back-link" id="back-link">[ESC] SALIR</a>
        <button class="audio-toggle" id="audio-toggle" type="button" title="Silenciar / activar sonido" aria-label="Silenciar / activar sonido">♪</button>
        <div class="terminal" id="terminal"></div>
      </div>
    </div>

    <div class="crt-controls" aria-label="Controles del monitor">
      <div class="ctrl-group">
        <span class="ctrl-icon" title="Brillo" aria-label="Brillo">☼</span>
        <div class="ctrl-pair">
          <button class="ctrl-btn left"  data-ctrl="brt" data-dir="-1" title="Bajar brillo"><span class="arrow"></span></button>
          <button class="ctrl-btn right" data-ctrl="brt" data-dir="1"  title="Subir brillo"><span class="arrow"></span></button>
        </div>
      </div>
      <button class="ctrl-reset" data-ctrl="reset" title="Restablecer brillo y contraste" aria-label="Reset">⟲</button>
      <div class="ctrl-group">
        <span class="ctrl-icon" title="Contraste" aria-label="Contraste">◐</span>
        <div class="ctrl-pair">
          <button class="ctrl-btn left"  data-ctrl="cnt" data-dir="-1" title="Bajar contraste"><span class="arrow"></span></button>
          <button class="ctrl-btn right" data-ctrl="cnt" data-dir="1"  title="Subir contraste"><span class="arrow"></span></button>
        </div>
      </div>
    </div>

    <div class="power-led" title="POWER"></div>
  `;
}
